import { FOI_FOR_FD_SEQUENTIAL_MODALS_250623 } from "@faire/web-api--source/indigofair/settings/FOI_FOR_FD_SEQUENTIAL_MODALS_250623";

import { useFirstOrderIncentiveStore } from "../hooks/firstOrderIncentive/useFirstOrderIncentiveStore";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingFoiForFdSequentialModals = (): boolean => {
  const { isFirstOrderForFaireDirectIncentive } = useFirstOrderIncentiveStore();
  const settingValue = useSetting(FOI_FOR_FD_SEQUENTIAL_MODALS_250623, false);

  return isFirstOrderForFaireDirectIncentive && settingValue;
};

export const useAssignSettingFoiForFdSequentialModals = () =>
  useAssignSetting(FOI_FOR_FD_SEQUENTIAL_MODALS_250623);
